export default "/storefront/client/images/No-Spill.png";